// Replace with your Cloudflare Worker URL once deployed
export const TRACKING_API_URL = import.meta.env.PROD
  ? 'https://green-surf-2176.lawxcompany.workers.dev/track-event'
  : 'http://localhost:3000/track-event'; 